import { useEffect, useState } from 'react'

const QUERY = '(max-width: 767px)'

export const useIsMobile = (): boolean => {
    const [isMobile, setIsMobile] = useState(false)

    useEffect(() => {
        const media = window.matchMedia(QUERY)
        const read = () => setIsMobile(media.matches)

        read()
        media.addEventListener('change', read)

        return () => media.removeEventListener('change', read)
    }, [])

    return isMobile
}
